export default "__VITE_ASSET__DZT6HhKj__"